#import "../../../../../../../common/graphql/EntityDocumentsFields.graphql"
mutation AttachPurchaseOrderDocument(
  $input: AttachPurchaseOrderDocumentInput!
) {
  attachPurchaseOrderDocument(input: $input) {
    entityDocuments {
      ...EntityDocumentsFields
    }
  }
}
